/**
 * Hareketsizlik nedeniyle otomatik çıkışın paylaşılan durumu.
 *
 * AuthWrapper kullanıcının son hareket anını burada tutar ve süre dolunca
 * oturumu kapatır. Bazı ekranlarda kullanıcı çalışırken sayfaya hiçbir olay
 * gelmez: iframe içindeki PDF/sunum kaydırması ana belgeye ulaşmaz, video
 * izlerken tıklanmaz, "Yeni sekmede aç" ile belge başka sekmede okunur. Böyle
 * ekranlar açıkken `holdSession()` ile tutucu alır; tutucu varken sınır
 * READING_IDLE_MS'e uzar (tamamen kapanmaz ki açık unutulan ekran oturumu
 * sonsuza dek açık tutmasın).
 *
 * Son hareket localStorage'a da yazılır: uygulama birden çok sekmede açıksa
 * birindeki hareket diğerinin oturumu kapatmasını engeller (Firebase çıkışı
 * tüm sekmeleri birlikte kapattığı için).
 */

export const IDLE_LIMIT_MS = 10 * 60 * 1000;
export const READING_IDLE_MS = 60 * 60 * 1000;

const STORAGE_KEY = 'habcare:lastActivity';

let lastActivity = Date.now();
let holds = 0;

export const markActivity = () => {
  lastActivity = Date.now();
  try {
    window.localStorage.setItem(STORAGE_KEY, String(lastActivity));
  } catch {
    // Depolama kapalıysa yalnızca bu sekmenin hareketi sayılır
  }
};

/** Bu sekmede ya da başka bir sekmede görülen en son hareket anı. */
export const getLastActivity = () => {
  try {
    const shared = Number(window.localStorage.getItem(STORAGE_KEY));
    return Number.isFinite(shared) ? Math.max(lastActivity, shared) : lastActivity;
  } catch {
    return lastActivity;
  }
};

export const getIdleLimit = () => (holds > 0 ? READING_IDLE_MS : IDLE_LIMIT_MS);

/** Sınırı uzatır; dönen fonksiyon tutucuyu bırakır (bir kez çalışır). */
export const holdSession = () => {
  holds += 1;
  markActivity();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holds -= 1;
    // Okuma bittiği an sayılır; kalan 10 dakika buradan başlar
    markActivity();
  };
};
